/**
 * The backend never returns an empty profilePic: ProfilePictureService swaps in this
 * placeholder when profile_pic is NULL, and builds a URL ending in "/public/" when it
 * is ''. Both mean "no photo", so `sp.profilePic` alone can't tell.
 *
 * The real filter is the `withPhotoOnly` param on /public/DownloadServiceProviders
 * (applied in SQL, before LIMIT). This check is the client-side backstop.
 */
const DEFAULT_PROFILE_IMAGE = 'default-profile-image-3D.jpg'

export const hasRealPhoto = (sp) => {
    const pic = sp?.profilePic
    return Boolean(pic) && !pic.endsWith(DEFAULT_PROFILE_IMAGE) && !pic.endsWith('/public/')
}
